export enum UserRole {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  SUPERADMIN = 'SUPERADMIN',
  USER = 'USER',
  EAR_TAG_TECHNICIAN = 'EAR_TAG_TECHNICIAN',
  NO_LOGGED_IN_USER = '',
}
